const urlBase = '#{AFFIXE2_API_BASE_URL}#/api/';

export default {
  URL_SERVEUR: urlBase,
  BASE_URL_GESCOM: urlBase + 'services/',
};
